<template>
  <base-dialog
    :title="`${isEditMode ? 'Update' : 'Create'} Event Item`"
    :action="onAction"
    :action-name="`${isEditMode ? 'Update' : 'Create'}`"
    :close="onClose"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            v-model="model.label"
            label="Label"
          />
          <v-select
            outlined
            dense
            v-model="model.type"
            :items="types"
            item-value="id"
            item-text="label"
            label="Type"
          />
        </v-col>
      </v-row>
      <template v-if="model.type === 'task'">
        <div class="headline">
          Task Details
        </div>
        <v-divider />
        <event-item-task-form
          :event-item="model"
          @change="changeMeta"
        />
      </template>
      <template v-if="model.type === 'alert'">
        <div class="headline">
          Alert Details
        </div>
        <v-divider />
        <event-item-alert-form
          :event-item="model"
          @change="changeMeta"
        />
      </template>
    </template>
  </base-dialog>
</template>

<script>
import { isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import BaseDialog from "../Common/BaseDialog"
import EventItemTaskForm from "./EventItemTaskForm"
import EventItemAlertForm from "./EventItemAlertForm"

export default {
  components: {
    EventItemAlertForm,
    BaseDialog,
    EventItemTaskForm
  },
  props: {
    // required for creating & updating
    eventId: {
      type: String,
      required: true,
      default: ''
    },
    // required for updating
    eventItem: {
      type: Object,
      default: () => ({})
    },
    eventGroupId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isEditMode: false,
      model: {
        id: null,
        label: '',
        description: '',
        meta: {},
      },
      types: [
        {
          id: 'task',
          label: 'Task'
        },
        {
          id: 'alert',
          label: 'Alert'
        },
        {
          id: 'email',
          label: 'Email'
        },
        {
          id: 'sms',
          label: 'SMS'
        },
        {
          id: 'api',
          label: 'API'
        },
        {
          id: 'pubsub',
          label: 'Pub / Sub'
        },
      ],
    }
  },
  watch: {
    eventItem() {
      this.model = { ...this.eventItem }
    }
  },
  mounted() {
    this.model = { ...this.eventItem }
    this.isEditMode = !isEmpty(this.model.id)
  },
  methods: {
    ...mapActions([ 'createEventItem', 'updateEventItem' ]),
    resetModel() {
      const reset = {
        id: null,
        label: '',
        description: '',
        meta: {}
      }

      this.model = { ...reset }
    },
    changeMeta(meta) {
      this.model.meta = { ...meta }
    },
    async onAction() {
      const payload = {
        ...this.model,
        eventId: this.eventId,
        eventGroupId: this.eventGroupId || undefined
      }

      console.log('action', this.isEditMode, payload)

      this.isEditMode
        ? await this.updateEventItem(payload).then(() => { this.resetModel() })
        : await this.createEventItem(payload).then(() => { this.resetModel() })
    },
    async onClose() {
      console.log('closed')
      this.resetModel()
    },
    handleError(e) {
      const errMsg = e.response.data.message
      this.$store.commit('showSnack', { text: errMsg, color: 'error' })
    },
  }
}
</script>
